import {setMap} from '.'

const initClientHooks = (/** @type {Hooks} */ hooks) => {
	hooks.render.initRenderContext.tap('region-urls', context => {
		setMap(context.state.__REGIONURLS__)
	})
}

export default initClientHooks
